import React from 'react';

const SchemaPediatricNephrology = () => {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "What is Pediatric Nephrology?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Pediatric Nephrology is a medical specialty that focuses on diagnosing and treating kidney-related diseases in infants, children, and adolescents."
        }
      },
      {
        "@type": "Question",
        "name": "When should I take my child to a pediatric nephrologist in Patna?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "You should consult a specialist if your child has symptoms like swelling, blood in urine, frequent infections, or abnormal urination patterns."
        }
      },
      {
        "@type": "Question",
        "name": "What are the common kidney diseases in children?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Common conditions include nephrotic syndrome, urinary tract infections (UTIs), kidney stones, acute kidney injury, and chronic kidney disease."
        }
      },
      {
        "@type": "Question",
        "name": "Is kidney disease in children curable?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Many kidney conditions in children are treatable if diagnosed early. Some chronic conditions require long-term management but can be controlled effectively."
        }
      },
      {
        "@type": "Question",
        "name": "What tests are done to diagnose kidney problems in children?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Doctors may recommend blood tests, urine tests, ultrasound imaging, and in some cases, a kidney biopsy for accurate diagnosis."
        }
      },
      {
        "@type": "Question",
        "name": "Is dialysis safe for children?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, pediatric dialysis is safe when performed under expert supervision. It helps manage kidney failure and supports overall health."
        }
      },
      {
        "@type": "Question",
        "name": "What is the difference between adult and pediatric nephrology?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Children require specialized care because their bodies are still developing, and kidney diseases can affect growth and development differently than in adults."
        }
      },
      {
        "@type": "Question",
        "name": "Can children undergo kidney transplant?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, kidney transplants can be successfully performed in children, with proper evaluation and post-transplant care."
        }
      },
      {
        "@type": "Question",
        "name": "How can I keep my child’s kidneys healthy?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Ensure proper hydration, balanced diet, timely treatment of infections, and regular health checkups to maintain kidney health."
        }
      },
      {
        "@type": "Question",
        "name": "Why choose HDNA Aarogyam Hospital for pediatric nephrology in Patna?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "HDNA Aarogyam offers expert specialists, advanced technology, child-friendly care, and comprehensive treatment under one roof."
        }
      }
    ]
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
    />
  );
};

export default SchemaPediatricNephrology;